module.exports = __webpack_public_path__ + "img/service-banner5.ce37e92c.png";